module.exports = __webpack_public_path__ + "static/img/bg.f099dfe.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/commonQifuPop/bg.png
// module id = 321
// module chunks = 32